import { Events } from "./eventBus";
// Seam: store/index.js is per-app - see the note in services/api.js.
import store from "@/store";
import { hasEnoughCredits } from "../utils/creditUtils";

// Store a reference to the Vue app instance for accessing $root
let vueAppInstance = null;

/**
 * Service to handle dialog-related functionality across the application
 */
export const DialogService = {
  /**
   * Set the Vue app instance reference
   * @param {Vue} app - The Vue app instance
   */
  setAppInstance(app) {
    vueAppInstance = app;
  },

  /**
   * Run an action only when the user holds enough credits for it.
   * If the balance is insufficient, shows the standard credit warning dialog
   * (handled by CreditWarningDialog) with an upgrade/purchase call to action
   * instead of running the action.
   *
   * @param {Function} action - Invoked when the user has enough credits.
   */
  openCreditGatedAction(action) {
    const creditBalance = store.getters.creditBalance;
    const isFreePlan = creditBalance && creditBalance.plan === "free";
    const hasEnough = hasEnoughCredits(creditBalance).hasEnough;

    if (!hasEnough) {
      // Show a dialog with appropriate message and action buttons using $root
      // This matches how CreditWarningDialog listens for the event
      if (vueAppInstance) {
        vueAppInstance.$emit(Events.SHOW_DIALOG, {
          title: "Insufficient Credits",
          message: `You don't have enough credits for this action (${
            creditBalance ? creditBalance.balance : 0
          } available).`,
          actions: [
            {
              text: isFreePlan ? "Upgrade Plan" : "Purchase Credits",
              handler: () =>
                isFreePlan
                  ? this.navigateTo("/subscribe")
                  : this.navigateTo("/billing")
            }
          ]
        });
      }
      return;
    }

    if (typeof action === "function") {
      action();
    }
  },

  /**
   * Navigate to a specific route
   * @param {string} route - The route to navigate to
   */
  navigateTo(route) {
    // Use the global router instance that's set in main.js
    if (window.router) {
      window.router.push(route);
    }
  }
};

export default DialogService;
